/* ============================================================
   MyPokea — Collections spéciales (showcase page)
   ============================================================ */

const sp_params = new URLSearchParams(location.search);
const CAT_ID = sp_params.get("cat") || "shiny";

/* Vraie photo produit du site, jamais un sprite officiel — utilisée quand aucune photo
   réelle n'existe encore pour un Pokémon/une catégorie donnée. */
const GENERIC_REAL_FALLBACK_IMG = "https://cdn.shopify.com/s/files/1/0972/9173/1277/files/Pokemon-Bulbizarre-Bulbasaur-Bisasam-001-figurine-finger-puppet-v4.webp?v=1782133857";

function _altStd(name, num) {
  const parts = ['Finger puppet', 'Figurine Pokémon', 'Pokémon Kids', name || ''];
  if (num != null) parts.push('N°' + String(num).padStart(3, '0'));
  return parts.join(' | ');
}

// Handles Shopify à essayer dans l'ordre pour chaque catégorie
const SPECIALS_SHOPIFY = {
  shiny:    ['shinies', 'shiny', 'pokemon-shiny', 'shiny-pokemon'],
  ultra:    ['ultra-chimeres', 'ultra-chimere', 'ultra-beasts', 'ultra-beast', 'ultra'],
  trainers: ['dresseurs'],
  mega:     ['mega-evolutions', 'mega', 'mega-evolution', 'megaevolution', 'pokemon-mega', 'mega-pokemon'],
  gmax:     ['gigamax', 'gmax', 'g-max', 'pokemon-gigamax', 'gigamax-pokemon'],
  pikachu:      ['pikachu', 'pokemon-pikachu', 'pikachus', 'pikachu-collection'],
  teracristal:  ['teracristal', 'tera-cristal', 'terastal', 'tera-crystal', 'pokemon-teracristal'],
  crystal:      ['transparente', 'transparentes', 'transparent', 'crystal', 'clear', 'pokemon-transparent', 'kids-transparent'],
};

// Tag Shopify de fallback si aucune collection ne correspond
const SPECIALS_TAGS = {
  mega: 'mega-evolution',
  crystal: 'transparent',
};

let _shopifySpecials = {};

async function _tryFetchCollection(handles) {
  for (const handle of handles) {
    try {
      const r = await fetch(`/collections/${handle}/products.json?limit=250`);
      if (!r.ok) continue;
      const data = await r.json();
      if (data.products && data.products.length) return data.products;
    } catch { continue; }
  }
  // Fallback : cherche dans toutes les collections par titre ou handle
  try {
    const r = await fetch(`/collections.json?limit=250`);
    if (r.ok) {
      const data = await r.json();
      const keywords = handles.concat(['transparent', 'cristal', 'crystal', 'clear']);
      const match = (data.collections || []).find(c => {
        const t = (c.title || '').toLowerCase();
        const h = (c.handle || '').toLowerCase();
        return keywords.some(k => t.includes(k) || h.includes(k));
      });
      if (match) {
        const r2 = await fetch(`/collections/${match.handle}/products.json?limit=250`);
        if (r2.ok) {
          const d2 = await r2.json();
          if (d2.products && d2.products.length) return d2.products;
        }
      }
    }
  } catch {}
  return null;
}

async function _tryFetchByTag(tag) {
  try {
    const r = await fetch(`/collections/all/products.json?limit=250&tag=${encodeURIComponent(tag)}`);
    if (!r.ok) return null;
    const data = await r.json();
    return data.products && data.products.length ? data.products : null;
  } catch { return null; }
}

document.addEventListener("DOMContentLoaded", () => {
  renderCatStrip();
  let handles = SPECIALS_SHOPIFY[CAT_ID] ? [...SPECIALS_SHOPIFY[CAT_ID]] : null;
  // Le handle injecté par Shopify Liquid a priorité absolue
  if (CAT_ID === 'crystal' && window.CRYSTAL_COLLECTION_HANDLE) {
    handles = [window.CRYSTAL_COLLECTION_HANDLE, ...(handles || [])];
  }
  const fallbackTag = SPECIALS_TAGS[CAT_ID];
  if (handles) {
    _tryFetchCollection(handles).then(async products => {
      if (!products && fallbackTag) products = await _tryFetchByTag(fallbackTag);
      if (products) {
        try {
          _shopifySpecials[CAT_ID] = products.map(p => {
            let name = p.title || '';
            const _num = (name.match(/n[°º]\s*0*(\d+)/i) || [])[1] || null;
            if (CAT_ID === 'trainers') {
              name = (name.match(/trainer\s*[—–-]\s*(.+)/i) || [])[1]?.trim() || name;
            } else if (CAT_ID === 'shiny') {
              const base = name.split(/\s*[—–\-]\s*/)[0].replace(/\bshiny\b/gi, '').trim();
              name = base ? `${base} · Shiny` : name;
            } else if (CAT_ID === 'mega') {
              let cleaned = name
                .replace(/^figurine\s+pok[eé]mon\s*(primo\s*)?/i, '')
                .replace(/\s*n°\s*\d+\s*$/i, '')
                .trim();
              const sepIdx = cleaned.search(/\s*[—–]\s*/);
              if (sepIdx > -1) {
                const before = cleaned.slice(0, sepIdx).trim();
                const after  = cleaned.slice(sepIdx).replace(/^\s*[—–]\s*/, '').trim();
                name = after.length <= 2 ? `${before} ${after}`.trim() : (before || after);
              } else {
                name = cleaned || name;
              }
            } else if (CAT_ID === 'gmax') {
              let cleaned = name
                .replace(/^figurine\s+pok[eé]mon\s*/i, '')
                .replace(/\s*n°\s*\d+\s*$/i, '')
                .trim();
              const sepIdx = cleaned.search(/\s*[—–]\s*/);
              if (sepIdx > -1) cleaned = cleaned.slice(0, sepIdx).trim();
              name = cleaned || name;
            } else if (CAT_ID === 'crystal') {
              let cleaned = name
                .replace(/^figurine\s+pok[eé]mon\s*/i, '')
                .replace(/\s*(transparent[e]?|crystal|clear)\s*/gi, '')
                .replace(/\s*n°\s*\d+\s*$/i, '')
                .trim();
              const sepIdx = cleaned.search(/\s*[—–]\s*/);
              if (sepIdx > -1) cleaned = cleaned.slice(0, sepIdx).trim();
              name = (cleaned || name) + ' · Clear';
            }
            const _tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(t => t.trim());
            return {
              name,
              num:      _num,
              img:      p.images && p.images[0] ? p.images[0].src : null,
              price:    p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : null,
              url:      `/products/${p.handle}`,
              avail:    p.variants ? p.variants.some(v => v.available) : false,
              featured: _tags.some(t => t.toLowerCase() === 'featured'),
              isHero:   _tags.some(t => t.toLowerCase() === `hero-${CAT_ID}`),
            };
          });
        } catch (e) {
          console.error('[speciales] mapping error:', e);
        }
      }
      renderCatContent();
    }).catch(() => renderCatContent());
  } else {
    renderCatContent();
  }
});

function renderCatStrip() {
  const root = document.getElementById("cat-strip");
  if (!root) return;
  root.innerHTML = POKE.SPECIALS.filter(c => !c.boutique).map(c => `
    <a class="gen-strip-item ${c.id === CAT_ID ? 'active' : ''}" href="/pages/speciales?cat=${c.id}">
      ${c.name}
      <span class="jp" style="font-size:12px; opacity:0.6;">${c.kanji}</span>
    </a>
  `).join("");
}

/* ---- shared state ---- */
let selState = { q: "", sort: "num-asc" };
let CUR_CAT = null;

function selHas(key) { return window.Bundle && Bundle.has(key); }
function selToggle(pick) { if (window.Bundle) Bundle.toggle(pick); }

function renderCatContent() {
  const cat = POKE.SPECIALS.find(c => c.id === CAT_ID) || POKE.SPECIALS[0];
  CUR_CAT = cat;
  const crumb = document.getElementById("crumb-cat");
  if (crumb) crumb.textContent = cat.name;
  document.title = cat.metaTitle || (CAT_ID === 'shiny'
    ? 'Shiny Pokémon : figurines Kids Bandai ultra-rares du Japon — MyPokea'
    : `${cat.name} — Collections spéciales — MyPokea`);
  if (cat.metaDesc) {
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement('meta'); m.setAttribute('name', 'description'); document.head.appendChild(m); }
    m.setAttribute('content', cat.metaDesc);
  }
  const root = document.getElementById("cat-content");
  if (!root) return;

  const shopifyProds = _shopifySpecials[cat.id];
  const heroCount = shopifyProds ? shopifyProds.length : cat.figures.length;
  const heroPrice = shopifyProds && shopifyProds.length
    ? Math.min(...shopifyProds.filter(p => p.price).map(p => p.price))
    : cat.priceFrom;

  const heroH1    = CAT_ID === 'shiny' ? 'Shiny Pokémon : figurines Kids Bandai ultra-rares du Japon' : cat.name;
  const heroBlurb = CAT_ID === 'shiny'
    ? `Dans l'univers Pokémon, le terme <strong>shiny</strong> désigne une version alternative d'un Pokémon, dotée d'une couleur différente et extrêmement rare. Si les shiny sont bien connus des joueurs via les jeux vidéo et les cartes Pokémon, ils existent également sous forme de <strong>figurines officielles</strong>, et c'est là que tout devient sérieux pour les collectionneurs.`
    : cat.blurb;

  root.innerHTML = `
    <section class="gen-hero${CAT_ID === 'shiny' ? ' gen-hero--shiny' : ''}" style="--gen-color: ${cat.color}; --gen-deep: ${cat.accentDeep || cat.color};">
      <div class="gen-hero-info">
        <span class="gen-hero-tag">${cat.jpRomaji} · ${cat.years}</span>
        <h1 class="gen-hero-title">${heroH1}</h1>
        <p class="gen-hero-blurb">${heroBlurb}</p>
        <div class="gen-hero-stats">
          <div><b>${heroCount}</b><span>figurines</span></div>
          <div><b>dès ${heroPrice.toFixed(2).replace('.', ',')} €</b><span>à l'unité</span></div>
          <div><b>-10 %</b><span>bundle dès 5</span></div>
        </div>
      </div>
      <div class="gen-hero-visual">
        <span class="gen-hero-kanji" aria-hidden="true">${cat.kanji}</span>
        <i class="gen-hero-shape ghs-star" aria-hidden="true"></i>
        <i class="gen-hero-shape ghs-ring" aria-hidden="true"></i>
        <i class="gen-hero-shape ghs-plus" aria-hidden="true"></i>
        <i class="gen-hero-shape ghs-diamond" aria-hidden="true"></i>
        <div class="gen-hero-discs">${heroMascots(cat)}</div>
      </div>
    </section>

    <div class="dex-filters">
      <label class="dex-search">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3-3"/></svg>
        <input type="search" id="sp-search" placeholder="Chercher dans ${cat.name}…" value="${selState.q}">
      </label>
      <select class="dex-sort" id="sp-sort">
        <option value="num-asc">Ordre catalogue</option>
        <option value="name-asc">Nom A → Z</option>
        <option value="price-asc">Prix croissant</option>
        <option value="price-desc">Prix décroissant</option>
      </select>
    </div>
    <div class="dex-stats-strip" id="sp-stats"></div>
    <div class="dex-grid" id="sp-grid"></div>
  `;

  document.getElementById("sp-search").addEventListener("input", e => { selState.q = e.target.value; renderGrid(cat); });
  document.getElementById("sp-sort").onchange = e => { selState.sort = e.target.value; renderGrid(cat); };

  window._bundleSyncBadges = () => syncBadges();
  renderGrid(cat);
  renderCatSEO();
}

function renderCatSEO() {
  document.getElementById('cat-seo-inject')?.remove();
  const SEO_INJECTED = ['shiny', 'gmax', 'crystal'];
  document.querySelectorAll('.seo-wrap, .faq-section').forEach(el => {
    el.style.display = SEO_INJECTED.includes(CAT_ID) ? 'none' : '';
  });
  if (!SEO_INJECTED.includes(CAT_ID)) return;

  const el = document.createElement('div');
  el.id = 'cat-seo-inject';

  if (CAT_ID === 'gmax') {
    el.innerHTML = `
<section class="seo-wrap">
  <div class="container">
    <div class="shiny-seo-intro">
      <h1>Gigamax Pokémon Kids Bandai : les figurines géantes de la série G-Max</h1>
      <p>Dans l'univers Pokémon Épée et Bouclier, le phénomène <strong>Gigamax</strong> transforme certains Pokémon en versions géantes aux formes entièrement redessinées. Contrairement au Dynamax qui agrandit simplement les Pokémon, le <strong>Gigamax</strong> leur confère une apparence unique propre à chaque espèce — Dracaufeu Gigamax devient un dragon enflammé d'une taille colossale, Pikachu Gigamax retrouve ses proportions rondes de la première génération en version XXL.</p>
      <p>Notre boutique propose une sélection de <strong>figurines Pokémon Kids Gigamax Bandai</strong>, issues du set G-Max sorti en novembre 2020 au Japon dans le cadre de la série Épée &amp; Bouclier. Au format agrandi par rapport aux Kids classiques, ces 12 figurines ont été commercialisées très peu de temps en exclusivité japonaise, ce qui en fait aujourd'hui des pièces recherchées par les collectionneurs européens.</p>
    </div>
    <div class="seo-row">
      <div class="seo-text">
        <span class="eyebrow">Série G-Max · Épée &amp; Bouclier</span>
        <h2>Qu'est-ce qu'une figurine <span class="hl">Gigamax</span> Kids Bandai ?</h2>
        <p>Le set G-Max est une édition limitée de la gamme Pokémon Kids, sortie en novembre 2020 pour accompagner le DLC de Pokémon Épée &amp; Bouclier au Japon. Chaque figurine reprend la forme Gigamax du Pokémon concerné : des designs spectaculaires avec des détails propres à chaque espèce, impossibles à confondre avec leur version normale.</p>
        <p>Le format est légèrement agrandi par rapport aux Pokémon Kids standard, respectant ainsi l'aspect colossal des formes Gigamax dans les jeux vidéo. Ces figurines en PVC souple reprennent les codes qualité Bandai : finition soignée, couleurs fidèles aux jeux, marquage officiel sur la base.</p>
        <h3 class="seo-h3">Des poses dynamiques inédites</h3>
        <p>Contrairement aux Kids classiques qui adoptent des poses neutres, les Gigamax bénéficient de poses dynamiques inspirées de leurs animations dans le jeu. Un choix artistique qui renforce leur identité de collector et les distingue immédiatement de la gamme standard.</p>
        <ul class="seo-points">
          <li>Format agrandi par rapport aux Kids classiques</li>
          <li>Poses dynamiques propres à chaque forme Gigamax</li>
          <li>PVC souple, qualité Bandai officielle</li>
          <li>Sortie exclusive novembre 2020 au Japon</li>
        </ul>
      </div>
      <div class="seo-media">
        <div class="seo-collage">
          <image-slot id="seo-gmax-0-main" class="s-main" shape="rounded" placeholder="Figurines Gigamax Pokémon Kids"></image-slot>
          <image-slot id="seo-gmax-0-a" class="s-a" shape="rounded" placeholder="Détail G-Max"></image-slot>
          <image-slot id="seo-gmax-0-b" class="s-b" shape="rounded" placeholder="Ambiance collection"></image-slot>
          <span class="s-chip">キョダイマックス</span>
        </div>
      </div>
    </div>
    <div class="seo-row flip">
      <div class="seo-text">
        <span class="eyebrow">Les 12 figurines du set</span>
        <h2>La collection <span class="hl">G-Max</span> Bandai complète</h2>
        <p>Le set G-Max Bandai réunit 12 figurines Gigamax : <strong>Pikachu, Dracaufeu, Ronflex, Ectoplasma, Corvaknight, Papilusion, Évoli, Miaouss, Carchacrok, Crabominable, Salarsen</strong> et <strong>Mistigrix</strong>. Un choix qui mêle les grands classiques de la licence avec des Pokémon emblématiques de la région de Galar.</p>
        <h3 class="seo-h3">Une série introuvable en Europe</h3>
        <p>Commercialisées uniquement au Japon pendant une période très limitée, ces figurines n'ont jamais fait l'objet d'une distribution européenne. Notre boutique importe directement depuis le Japon, permettant aux collectionneurs français d'accéder à cette série que l'on ne trouve nulle part ailleurs en boutique classique.</p>
        <ul class="seo-points">
          <li>12 figurines Gigamax dans le set complet</li>
          <li>Jamais distribué en Europe</li>
          <li>Importées directement du Japon</li>
          <li>Stock limité selon les arrivages</li>
        </ul>
      </div>
      <div class="seo-media">
        <div class="seo-collage">
          <image-slot id="seo-gmax-1-main" class="s-main" shape="rounded" placeholder="Collection G-Max complète"></image-slot>
          <image-slot id="seo-gmax-1-a" class="s-a" shape="rounded" placeholder="Détail"></image-slot>
          <image-slot id="seo-gmax-1-b" class="s-b" shape="rounded" placeholder="Ambiance"></image-slot>
          <span class="s-chip">ガラル地方</span>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section faq-section">
  <div class="container">
    <div class="section-eyebrow" style="flex-direction:column; gap:6px; align-items:flex-start;">
      <h2 class="section-title" style="font-size:clamp(20px,2.6vw,34px);">FAQ – Figurines <span class="hl">Gigamax</span> Pokémon Kids</h2>
      <h3 style="font-size:clamp(14px,1.4vw,18px); font-weight:600; color:var(--ink-2); margin:0; letter-spacing:-0.01em;">Questions fréquentes sur les Gigamax Kids Bandai</h3>
    </div>
    <div class="faq-grid">
      <details class="faq-item">
        <summary>Qu'est-ce qu'un Pokémon Gigamax ?</summary>
        <div class="faq-body">Le Gigamax est un phénomène exclusif à certains Pokémon dans les jeux Pokémon Épée et Bouclier. Contrairement au Dynamax qui agrandit n'importe quel Pokémon, le Gigamax transforme uniquement des individus rares avec une apparence entièrement redessinée et une forme unique propre à chaque espèce.</div>
      </details>
      <details class="faq-item">
        <summary>Les figurines Gigamax Kids sont-elles différentes des Kids classiques ?</summary>
        <div class="faq-body">Oui, les figurines Gigamax du set G-Max Bandai sont proposées dans un format légèrement agrandi par rapport aux Pokémon Kids standard, avec des poses dynamiques spécifiques à chaque forme Gigamax. Leur design est fidèle aux apparences vues dans Pokémon Épée &amp; Bouclier.</div>
      </details>
      <details class="faq-item">
        <summary>Combien y a-t-il de figurines dans le set G-Max Bandai ?</summary>
        <div class="faq-body">Le set G-Max Bandai comprend 12 figurines : Gigamax Pikachu, Dracaufeu, Ronflex, Ectoplasma, Corvaknight, Papilusion, Évoli, Miaouss, Carchacrok, Crabominable, Salarsen et Mistigrix.</div>
      </details>
      <details class="faq-item">
        <summary>Ces figurines sont-elles officielles ?</summary>
        <div class="faq-body">Oui, le set G-Max est une série officielle sous licence Pokémon, produite par Bandai et commercialisée au Japon en novembre 2020. Toutes les figurines que nous proposons sont des produits authentiques importés directement du Japon.</div>
      </details>
      <details class="faq-item">
        <summary>Pourquoi le set G-Max est-il difficile à trouver ?</summary>
        <div class="faq-body">Le set a été commercialisé uniquement au Japon pendant une durée très limitée et n'a jamais été distribué en Europe. Les stocks sont épuisés depuis longtemps dans les boutiques japonaises, ce qui en fait un objet de collection recherché, notamment par les fans de Galar et d'Épée &amp; Bouclier.</div>
      </details>
      <details class="faq-item">
        <summary>Un Gigamax Kids convient-il comme cadeau ?</summary>
        <div class="faq-body">Absolument. Un Gigamax Kids Bandai est un cadeau original et inattendu pour tout fan de Pokémon Épée &amp; Bouclier ou collectionneur de figurines japonaises. Ces pièces introuvables en boutique classique en Europe constituent un cadeau rare et mémorable.</div>
      </details>
    </div>
  </div>
</section>`;
  } else if (CAT_ID === 'crystal') {
    el.innerHTML = `
<section class="seo-wrap">
  <div class="container">
    <div class="shiny-seo-intro">
      <h1>Figurines Pokémon Kids Bandai Transparentes — éditions Clear &amp; Cristal</h1>
      <p>Les <strong>figurines Pokémon Kids transparentes</strong> sont des éditions spéciales en plastique <strong>PVC souple entièrement transparent</strong> — parfois teinté bleu, rouge, doré ou irisé — produites par Bandai depuis les années 1990. Distinctes des Kids classiques par leur matière, ces pièces ont été distribuées en <strong>capsule-gacha</strong> au Japon, en coffrets limités Pokémon Center, ou lors d'événements exclusifs. Chaque figurine laisse apparaître sa structure interne en transparence, créant un effet visuel unique impossible à reproduire avec les versions standards.</p>
      <p>Notre boutique propose une sélection de <strong>figurines Kids Bandai transparentes</strong>, importées directement du Japon. Ces éditions clear couvrent toutes les générations — de Pikachu à Mewtwo, de Lugia à Arceus — et constituent certaines des pièces les plus recherchées par les collectionneurs européens, introuvables en boutique classique en dehors du Japon.</p>
    </div>
    <div class="seo-row">
      <div class="seo-text">
        <span class="eyebrow">Éditions Clear &amp; Cristal · Bandai depuis les années 90</span>
        <h2>Qu'est-ce qu'une figurine Kids <span class="hl">transparente</span> Bandai ?</h2>
        <p>Les figurines transparentes Kids Bandai sont fabriquées dans le même PVC souple que les Kids standard, mais <strong>sans pigmentation opaque</strong>. Le résultat est une figurine entièrement translucide qui capte la lumière différemment selon l'angle — certaines versions sont incolores (clear), d'autres sont teintées d'une couleur unique (bleu glacé, rouge rubis, doré) qui renforce l'effet collector. Ces éditions ont été produites en <strong>très petits tirages</strong>, souvent distribués exclusivement via les distributeurs automatiques gacha japonais ou dans les Pokémon Center de Tokyo et Osaka.</p>
        <ul class="seo-points">
          <li>PVC souple transparent · versions incolores, teintées ou irisées</li>
          <li>Distribution gacha japonaise ou coffrets Pokémon Center · jamais en boutique classique</li>
          <li>Couvrent toutes les générations · Kanto à Sinnoh et au-delà</li>
        </ul>
      </div>
      <div class="seo-media">
        <div class="seo-collage">
          <image-slot id="seo-crystal-0-main" class="s-main" shape="rounded" placeholder="Figurines Kids transparentes"></image-slot>
          <image-slot id="seo-crystal-0-a" class="s-a" shape="rounded" placeholder="Détail clear Kids"></image-slot>
          <image-slot id="seo-crystal-0-b" class="s-b" shape="rounded" placeholder="Collection transparente"></image-slot>
          <span class="s-chip">クリア</span>
        </div>
      </div>
    </div>
    <div class="seo-row flip">
      <div class="seo-text">
        <span class="eyebrow">Les pièces les plus recherchées · Clear légendaires</span>
        <h2>Mewtwo, Lugia, Arceus : les <span class="hl">légendaires</span> en version transparente</h2>
        <p>Les figurines Kids transparentes les plus demandées sont sans surprise les Pokémon légendaires et iconiques. <strong>Mewtwo transparent</strong> (#150) est l'une des pièces clear les plus recherchées, sa couleur naturellement pâle rendant la transparence particulièrement saisissante. <strong>Lugia transparent</strong> (#249) et <strong>Ho-Oh transparent</strong> (#250) — les mascottes de Pokémon Or et Argent — existent en version clear et sont parmi les Kids transparents les plus difficiles à trouver. <strong>Dracaufeu transparent</strong> (#006), <strong>Rayquaza transparent</strong> (#384) et <strong>Arceus transparent</strong> (#493) complètent les pièces légendaires que les collectionneurs recherchent activement. <strong>Pikachu transparent</strong> (#025), dans ses nombreuses déclinaisons clear, est la figurine la plus distribuée de la gamme — elle reste l'une des plus accessibles et des plus populaires.</p>
      </div>
      <div class="seo-media">
        <div class="seo-collage">
          <image-slot id="seo-crystal-1-main" class="s-main" shape="rounded" placeholder="Mewtwo Lugia transparent Kids"></image-slot>
          <image-slot id="seo-crystal-1-a" class="s-a" shape="rounded" placeholder="Dracaufeu Rayquaza clear"></image-slot>
          <image-slot id="seo-crystal-1-b" class="s-b" shape="rounded" placeholder="Arceus Pikachu transparent"></image-slot>
          <span class="s-chip">伝説</span>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section faq-section">
  <div class="container">
    <div class="section-eyebrow" style="flex-direction:column; gap:6px; align-items:flex-start;">
      <h2 class="section-title" style="font-size:clamp(20px,2.6vw,34px);">FAQ – Figurines Pokémon Kids <span class="hl">Transparentes</span></h2>
      <h3 style="font-size:clamp(14px,1.4vw,18px); font-weight:600; color:var(--ink-2); margin:0; letter-spacing:-0.01em;">Questions fréquentes sur les éditions Clear &amp; Cristal Kids Bandai</h3>
    </div>
    <div class="faq-grid">
      <details class="faq-item">
        <summary>Qu'est-ce qu'une figurine Kids Bandai transparente ?</summary>
        <div class="faq-body">Une figurine Kids Bandai transparente est fabriquée en PVC souple entièrement translucide, sans pigmentation opaque. Certaines versions sont incolores (clear), d'autres sont teintées d'une couleur spécifique — bleu, rouge, doré ou irisé. Ce sont des éditions spéciales distinctes des Kids classiques, produites en très petits tirages au Japon.</div>
      </details>
      <details class="faq-item">
        <summary>Ces figurines transparentes sont-elles des produits officiels Bandai ?</summary>
        <div class="faq-body">Oui — toutes nos figurines Kids transparentes sont des produits officiels sous licence Pokémon, fabriquées par Bandai. Elles ont été distribuées via des capsules-gacha japonaises ou dans les Pokémon Center de Tokyo et Osaka, jamais commercialisées en boutique classique en dehors du Japon.</div>
      </details>
      <details class="faq-item">
        <summary>Quelles sont les figurines transparentes les plus recherchées ?</summary>
        <div class="faq-body">Les Kids transparents les plus demandés sont les légendaires et les Pokémon iconiques : Mewtwo, Lugia, Dracaufeu, Rayquaza et Arceus en version clear sont particulièrement recherchés. Pikachu transparent existe en de nombreuses déclinaisons et reste le plus accessible. La valeur d'une pièce dépend du Pokémon, de sa teinte et de la rareté de la série de distribution.</div>
      </details>
      <details class="faq-item">
        <summary>Quelle différence entre une version clear incolore et une version teintée ?</summary>
        <div class="faq-body">Une figurine clear incolore est entièrement transparente comme du verre souple — aucune couleur ajoutée. Une version teintée est fabriquée dans un plastique transparent coloré (bleu, rouge, doré, violet...) qui conserve la translucidité tout en ajoutant une teinte uniforme. Les versions teintées sont généralement produites en plus petits tirages et sont plus recherchées en collection.</div>
      </details>
      <details class="faq-item">
        <summary>Les figurines transparentes couvrent-elles toutes les générations ?</summary>
        <div class="faq-body">Bandai a produit des figurines Kids transparentes couvrant principalement les générations 1 à 4 — les plus anciennement distribuées via gacha. Des versions transparentes de Pokémon des générations suivantes existent mais sont plus rares. Notre sélection dans ce catalogue reflète les arrivages disponibles à l'import direct depuis le Japon.</div>
      </details>
      <details class="faq-item">
        <summary>Une figurine transparente convient-elle comme cadeau collector ?</summary>
        <div class="faq-body">Absolument. Une figurine Kids Bandai transparente est un cadeau rare et inattendu pour tout fan ou collectionneur — ces pièces ont un effet visuel très différent des Kids standards et sont introuvables en boutique classique en France. Leur rareté relative et leur origine japonaise en font des cadeaux de collection à part entière.</div>
      </details>
    </div>
  </div>
</section>`;
  } else {
  el.innerHTML = `
<section class="seo-wrap">
  <div class="container">
    <div class="shiny-seo-intro">
      <h1>Shiny Pokémon : figurines Kids Bandai ultra-rares du Japon</h1>
      <p>Dans l'univers Pokémon, le terme <strong>shiny</strong> désigne une version alternative d'un Pokémon, dotée d'une couleur différente et extrêmement rare. Si les shiny sont bien connus des joueurs via les jeux vidéo et les cartes Pokémon, ils existent également sous forme de figurines officielles, et c'est là que tout devient sérieux pour les collectionneurs.</p>
      <p>Notre boutique propose une sélection de figurines <strong>shiny Pokémon Kids Bandai</strong>, directement importées du Japon. Ces pièces <strong>jamais commercialisées</strong> en boutique classique : elles proviennent exclusivement de loteries japonaises organisées par le <strong>Pokémon Daisuki Club</strong>, ce qui en fait des pièces parmi les plus rares au monde.</p>
    </div>
    <div class="seo-row">
      <div class="seo-text">
        <span class="eyebrow">Figurines Pokémon Kids Bandai</span>
        <h2>Qu'est-ce qu'un <span class="hl">shiny</span> Pokémon Kids Bandai ?</h2>
        <p>Les <strong>Pokémon Kids</strong> sont de petites figurines en PVC souple produites par Bandai depuis 1996. Ces finger puppets mesurent entre 4 et 5 cm et représentent des centaines de Pokémon différents. Chaque figurine est creuse et se place historiquement au bout du doigt, d'où leur surnom de finger puppet. Ces figurines, comme les cartes Pokémon japonaises, sont devenues de véritables objets de collection.</p>
        <p>Les versions <strong>shiny</strong> de ces figurines constituent une catégorie à part entière. Contrairement aux Kids classiques disponibles en série, ces figurines n'ont jamais été distribuées en boutique ni sur le site officiel. Ils ont été proposés uniquement comme prix de loteries réservées aux membres du Pokémon Daisuki Club au Japon, avec des tirages limités à quelques centaines ou milliers d'exemplaires selon les versions.</p>
        <p>Ces figurines chromatiques reprennent fidèlement la palette de couleurs alternative du Pokémon concerné : un Dracaufeu chromatique arbore ainsi une teinte noire et rouge, bien loin de son orange habituel. C'est cette différence visuelle, combinée à leur extrême rareté, qui fait tout leur valeur.</p>
      </div>
      <div class="seo-media">
        <div class="seo-collage">
          <image-slot id="seo-shiny-0-main" class="s-main" shape="rounded" placeholder="Figurines shiny Pokémon Kids"></image-slot>
          <image-slot id="seo-shiny-0-a" class="s-a" shape="rounded" placeholder="Détail chromatique"></image-slot>
          <image-slot id="seo-shiny-0-b" class="s-b" shape="rounded" placeholder="Ambiance collection"></image-slot>
          <span class="s-chip">色違い</span>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="seo-final">
  <div class="container">
    <div class="seo-final-kanji">色</div>
    <div class="badge">Exclusivité japonaise</div>
    <h3>Des figurines shiny jamais commercialisées en Europe</h3>
    <p>Le temps où ces figurines shiny pouvaient être trouvées facilement est révolu. Aujourd'hui, dénicher une figurine de ce type en bon état représente un véritable défi, même au Japon. En Europe, elles sont quasiment introuvables en dehors des revendeurs spécialisés comme notre boutique, qui les importe directement depuis le Japon.</p>
    <p>Chaque figurine que nous proposons est :</p>
    <div class="shiny-final-list">
      <ul class="seo-points">
        <li>Issue d'une loterie officielle japonaise Pokémon</li>
        <li>Sous licence officielle Bandai / Pokémon Center</li>
        <li>Importée directement du Japon</li>
        <li>Disponible en quantité très limitée selon les arrivages</li>
      </ul>
    </div>
    <p>Certaines versions chromatiques sont également accompagnées de leur boîte et sticker d'origine, ce qui ajoute encore à leur valeur pour les collectionneurs.</p>
  </div>
</section>

<section class="seo-trust">
  <div class="container">
    <span class="seo-trust-kanji">希</span>
    <span class="eyebrow">Rareté exceptionnelle</span>
    <h3>Ce qui rend ces figurines uniques au monde</h3>
    <p class="seo-lead">Trois raisons qui expliquent l'engouement des collectionneurs pour ces pièces introuvables.</p>
    <div class="seo-trust-cards">
      <div class="seo-trust-card">
        <div class="seo-trust-ic">抽</div>
        <strong>Loterie officielle exclusive</strong>
        <p>Distribuées uniquement via les loteries du Pokémon Daisuki Club au Japon — jamais en vente libre dans le commerce.</p>
      </div>
      <div class="seo-trust-card">
        <div class="seo-trust-ic">限</div>
        <strong>Tirages ultra-limités</strong>
        <p>Quelques centaines à quelques milliers d'exemplaires seulement par version. Certains modèles n'existent qu'à quelques dizaines.</p>
      </div>
      <div class="seo-trust-card">
        <div class="seo-trust-ic">希</div>
        <strong>Introuvables en Europe</strong>
        <p>Jamais commercialisées hors du Japon. Importées directement et expédiées de France.</p>
      </div>
    </div>
  </div>
</section>

<section class="shiny-sub">
  <div class="container">
    <h3>Les Pokémon shiny les plus recherchés en figurine</h3>
    <div class="shiny-sub-inner">
      <p>Parmi ces figurines rares Bandai les plus populaires, on retrouve <strong>Dracaufeu shiny</strong>, Rayquaza shiny ou encore Evoli shiny. Ces Pokémon bénéficient d'une forte notoriété dans les jeux, et leurs versions chromatiques en figurine sont particulièrement prisées. Le <strong>prix</strong> d'un shiny Kids peut varier de 15 à plus de 80 euros selon le Pokémon, son état et la rareté de la version.</p>
      <p>Il existe différentes formes de shiny dans la gamme Kids. Les plus anciennes, issues des premières séries Daisuki Club des années 2000, sont aujourd'hui les plus rares. Les versions plus récentes, comme les figurines chromatiques distribuées lors des 30 ans des Pokémon Kids en 2026, sont un nouveau chapitre dans l'histoire de cette collection légendaire.</p>
    </div>
  </div>
</section>

<section class="shiny-sub shiny-sub--alt">
  <div class="container">
    <h3>Comment obtenir des informations sur les nouveaux arrivages ?</h3>
    <div class="shiny-sub-inner">
      <p>Notre stock de figurines shiny évolue régulièrement selon les arrivages directs depuis le Japon. Nous mettons à jour le catalogue dès qu'un nouveau lot arrive en stock. Pour recevoir les informations en temps réel sur les nouvelles pièces en stock, nous vous invitons à suivre notre boutique.</p>
      <p>Chaque fiche produit précise la version concernée, son état, son origine et son prix. Nous veillons à proposer des produits authentiques, bien documentés, pour que chaque achat soit fait en toute confiance.</p>
    </div>
  </div>
</section>

<section class="section faq-section">
  <div class="container">
    <div class="section-eyebrow" style="flex-direction:column; gap:6px; align-items:flex-start;">
      <h2 class="section-title" style="font-size:clamp(20px,2.6vw,34px);">FAQ – Figurines <span class="hl">shiny</span> Pokémon Kids</h2>
      <h3 style="font-size:clamp(14px,1.4vw,18px); font-weight:600; color:var(--ink-2); margin:0; letter-spacing:-0.01em;">Questions fréquentes sur les shiny Kids Bandai</h3>
    </div>
    <div class="faq-grid">
      <details class="faq-item">
        <summary>Qu'est-ce qu'un Pokémon shiny ?</summary>
        <div class="faq-body">Un Pokémon shiny est une version alternative dotée d'une couleur différente de la normale. Dans les jeux Pokémon, la probabilité d'en rencontrer un est de 1 sur 4096. En figurine, les chromatiques Bandai sont tout aussi rares, distribués uniquement via des loteries japonaises.</div>
      </details>
      <details class="faq-item">
        <summary>Ces figurines sont-elles officielles ?</summary>
        <div class="faq-body">Oui, toutes nos figurines chromatiques sont des produits officiels sous licence Pokémon, fabriquées par Bandai. Elles proviennent directement du Japon et n'ont jamais été commercialisées en Europe.</div>
      </details>
      <details class="faq-item">
        <summary>Pourquoi ces figurines sont-elles si rares et chères ?</summary>
        <div class="faq-body">Leur prix élevé s'explique par leur rareté extrême : distribuées uniquement en loterie japonaise, avec des tirages restreints, ces pièces n'existent qu'en quelques centaines d'exemplaires dans le monde. Le temps joue aussi : plus les années passent, plus elles se raréfient.</div>
      </details>
      <details class="faq-item">
        <summary>Comment savoir si une figurine shiny est authentique ?</summary>
        <div class="faq-body">Les figurines authentiques présentent des marquages Bandai sur la base, une qualité de finition précise et des couleurs bien définies. Nous sélectionnons uniquement des pièces vérifiées et vous fournissons toutes les informations nécessaires sur chaque produit.</div>
      </details>
      <details class="faq-item">
        <summary>Quels shiny sont en stock en ce moment ?</summary>
        <div class="faq-body">Notre stock varie selon les arrivages. Parmi les versions chromatiques que nous proposons régulièrement : Dracaufeu, Rayquaza, Evoli et d'autres Pokémon populaires. Consultez notre catalogue pour découvrir les modèles disponibles au moment de votre visite.</div>
      </details>
      <details class="faq-item">
        <summary>Un shiny Kids convient-il comme cadeau ?</summary>
        <div class="faq-body">Absolument. Une figurine chromatique Pokémon Kids est un cadeau rare et marquant pour tout fan ou collectionneur de Pokémon. C'est aussi un excellent investissement, au même titre que les cartes rares, pour ceux qui souhaitent constituer une collection de valeur avec des pièces japonaises introuvables en Europe.</div>
      </details>
    </div>
  </div>
</section>`;
  }

  const firstSeoWrap = document.querySelector('.seo-wrap');
  if (firstSeoWrap) firstSeoWrap.parentNode.insertBefore(el, firstSeoWrap);
  else document.querySelector('body').appendChild(el);
}

function heroMascots(cat) {
  const shopifyProds = _shopifySpecials[cat.id];
  if (shopifyProds && shopifyProds.length) {
    const heroTagged = shopifyProds.filter(p => p.isHero && p.img);
    const feat = shopifyProds.filter(p => p.featured && p.img);
    const toShow = (heroTagged.length ? heroTagged : feat.length >= 3 ? feat : shopifyProds.filter(p => p.img)).slice(0, 3);
    if (toShow.length) {
      return toShow.map(p =>
        `<a class="gen-disc" href="${p.url || '#'}" target="_blank" rel="noopener"><img src="${p.img}" alt="${_altStd(p.name, p.num)}" loading="lazy"></a>`
      ).join('');
    }
  }
  return cat.figures.slice(0, 3).map((f, i) => {
    return `<div class="gen-disc"><img src="${GENERIC_REAL_FALLBACK_IMG}" alt="${_altStd(f.n, f.id)}" loading="lazy"></div>`;
  }).join('');
}

function tileNum(cat, f) {
  if (cat.useSprite && f.id) return `#${String(f.id).padStart(3, '0')}`;
  if (f.region) return f.region;
  const tags = { mega: "Méga", gmax: "G-Max", dx: "DX", crystal: "Clear" };
  return tags[cat.id] || cat.name;
}

function buildList(cat) {
  let list = cat.figures.map((f, oi) => ({
    key: `${cat.id}-${oi}`,
    oi, id: f.id || null, name: f.n,
    region: f.region || null,
    price: POKE.specialPrice(cat, oi),
    image: GENERIC_REAL_FALLBACK_IMG,
    art: GENERIC_REAL_FALLBACK_IMG,
  }));
  if (selState.q.trim()) {
    const q = selState.q.trim().toLowerCase();
    list = list.filter(p => p.name.toLowerCase().includes(q) || (p.id && String(p.id).includes(q)));
  }
  const s = selState.sort;
  if (s === "num-asc") list.sort((a, b) => (a.id || a.oi) - (b.id || b.oi));
  if (s === "name-asc") list.sort((a, b) => a.name.localeCompare(b.name));
  if (s === "price-asc") list.sort((a, b) => a.price - b.price);
  if (s === "price-desc") list.sort((a, b) => b.price - a.price);
  return list;
}

function renderGrid(cat) {
  const shopifyProds = _shopifySpecials[cat.id];
  if (shopifyProds) { renderShopifyGrid(cat, shopifyProds); return; }
  // Static fallback (pour mega, gmax, crystal, dx et si collection Shopify absente)
  const root = document.getElementById("sp-grid");
  if (!root) return;
  const list = buildList(cat);

  const stats = document.getElementById("sp-stats");
  if (stats) stats.innerHTML = `
    <span><strong style="color:var(--ink);">${list.length}</strong> figurines</span>
    <span><strong style="color:var(--ink-2);">${cat.tagline}</strong></span>
    <span style="color:var(--ink-3); margin-left:auto; font-style: italic;">Clique pour ajouter à ta sélection — bundle -10 % dès 5 pièces.</span>
  `;

  root.innerHTML = list.map(p => {
    const picked = selHas(p.key);
    const media = `<img src="${p.art}" alt="${_altStd(p.name, p.id)}" loading="lazy" draggable="false" onerror="this.src='${GENERIC_REAL_FALLBACK_IMG}'">`;
    return `
      <div class="poke-tile ${picked ? 'picked' : ''}" data-key="${p.key}" title="${p.name} · ${p.price.toFixed(2).replace('.', ',')} €">
        <span class="poke-pick-badge" aria-hidden="true">${picked ? '✓' : ''}</span>
        <span class="poke-num">${tileNum(cat, { id: p.id, region: p.region })}</span>
        ${media}
        <div class="poke-name">${p.name}</div>
        <div class="poke-price">${p.price.toFixed(2).replace('.', ',')} €</div>
      </div>`;
  }).join("");

  root.querySelectorAll(".poke-tile").forEach(tile => {
    const p = list.find(x => x.key === tile.dataset.key);
    tile.onclick = () => {
      selToggle({ key: p.key, num: p.id, name: p.name, variant: `Collection ${CUR_CAT.name}${p.region ? ' · ' + p.region : ''}`, price: p.price, image: p.image, bg: CUR_CAT.color });
      tile.classList.add("just-added");
      setTimeout(() => tile.classList.remove("just-added"), 280);
    };
  });
}

const ZOOM_BTN = `<button type="button" class="poke-img-zoom" aria-label="Agrandir"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3-3"/></svg></button>`;

function renderShopifyGrid(cat, products) {
  const root = document.getElementById("sp-grid");
  if (!root) return;

  root.style.gridTemplateColumns = '';
  root.classList.toggle('sp-grid--shiny', cat.id === 'shiny');

  let list = products.slice();
  if (selState.q.trim()) {
    const q = selState.q.trim().toLowerCase();
    list = list.filter(p => p.name.toLowerCase().includes(q));
  }
  list.sort((a, b) => {
    const stockDiff = (a.avail === false ? 1 : 0) - (b.avail === false ? 1 : 0);
    if (stockDiff !== 0) return stockDiff;
    if (selState.sort === "name-asc") return a.name.localeCompare(b.name);
    if (selState.sort === "price-asc") return (a.price || 0) - (b.price || 0);
    if (selState.sort === "price-desc") return (b.price || 0) - (a.price || 0);
    return 0;
  });

  const inStock = list.filter(p => p.avail !== false).length;
  const stats = document.getElementById("sp-stats");
  if (stats) stats.innerHTML = `
    <span><strong style="color:var(--ink);">${list.length}</strong> figurines</span>
    <span><strong style="color:var(--green-deep);">${inStock}</strong> en stock</span>
    <span style="color:var(--ink-3); margin-left:auto; font-style: italic;">Clique pour ajouter à ta sélection — bundle -10 % dès 5 pièces.</span>
  `;

  root.innerHTML = list.map((p, i) => {
    const key = `${cat.id}-sp-${i}`;
    const picked = selHas(key);
    const oos = p.avail === false;
    const priceLabel = p.price ? p.price.toFixed(2).replace('.', ',') + ' €' : '';
    return `
      <div class="poke-tile trainer-tile${oos ? ' oos' : ''}${picked ? ' picked' : ''}" data-key="${key}" data-sp-idx="${i}" title="${p.name}${priceLabel ? ' · ' + priceLabel : ''}">
        <span class="poke-pick-badge" aria-hidden="true">${picked ? '✓' : ''}</span>
        <div class="poke-img-wrap">
          ${p.img ? `<img class="poke-img" src="${p.img}" alt="${_altStd(p.name, p.num)}" loading="lazy" draggable="false">` : `<div class="poke-img poke-img--placeholder"></div>`}
          ${!oos && p.img ? ZOOM_BTN : ''}
        </div>
        <div class="poke-info">
          <div class="poke-name">${p.name}</div>
        </div>
        <div class="poke-foot">
          <span class="poke-price">${priceLabel}</span>
          ${oos ? '<span class="poke-oos-label">Rupture</span>' : '<span class="poke-add-btn" aria-hidden="true">+</span>'}
        </div>
      </div>`;
  }).join("");

  root.querySelectorAll(".poke-tile[data-sp-idx]").forEach(tile => {
    const i = parseInt(tile.dataset.spIdx, 10);
    const p = list[i];
    const key = `${cat.id}-sp-${i}`;

    tile.querySelector(".poke-img-zoom")?.addEventListener("click", e => {
      e.stopPropagation();
      spOpenZoom(p.img, p.name, p.price, p.url);
    });

    tile.addEventListener("click", e => {
      if (e.target.closest(".poke-img-zoom")) return;
      if (tile.classList.contains("oos")) return;
      selToggle({ key, num: 0, name: p.name, variant: `Collection ${CUR_CAT.name}`, price: p.price || 0, image: p.img || '', bg: CUR_CAT.color, url: p.url });
      tile.classList.toggle("picked", selHas(key));
      const badge = tile.querySelector(".poke-pick-badge");
      if (badge) badge.textContent = selHas(key) ? "✓" : "";
    });
  });
}

function spOpenZoom(img, name, price, url) {
  let ov = document.getElementById("sp-zoom-overlay");
  if (!ov) {
    ov = document.createElement("div");
    ov.id = "sp-zoom-overlay";
    ov.className = "zoom-overlay";
    ov.innerHTML = `<div class="zoom-bd"></div><figure class="zoom-fig"><img id="sp-zoom-img" src="" alt=""><figcaption id="sp-zoom-cap"></figcaption><div id="sp-zoom-actions"></div></figure>`;
    document.body.appendChild(ov);
    ov.addEventListener("click", e => { if (e.target === ov || e.target.classList.contains("zoom-bd")) spCloseZoom(); });
    document.addEventListener("keydown", e => { if (e.key === "Escape") spCloseZoom(); });
  }
  ov.querySelector("#sp-zoom-img").src = img;
  ov.querySelector("#sp-zoom-img").alt = name;
  ov.querySelector("#sp-zoom-cap").textContent = price && price > 0 ? `${name} · ${price.toFixed(2).replace(".", ",")} €` : name;
  ov.querySelector("#sp-zoom-actions").innerHTML = url ? `<a class="zoom-product-btn" href="${url}" target="_blank" rel="noopener">Voir le produit →</a>` : '';
  ov.classList.add("open");
  document.body.style.overflow = "hidden";
}
function spCloseZoom() {
  const ov = document.getElementById("sp-zoom-overlay");
  if (ov) { ov.classList.remove("open"); document.body.style.overflow = ""; }
}

function syncBadges() {
  document.querySelectorAll("#sp-grid .poke-tile[data-key]").forEach(tile => {
    const on = selHas(tile.dataset.key);
    tile.classList.toggle("picked", on);
    const b = tile.querySelector(".poke-pick-badge");
    if (b) b.textContent = on ? "✓" : "";
  });
}
